/**
 * Rider Pre-Settlement API
 * 라이더 선정산내역 API (vr_rider_acct_daily 테이블 조회)
 */
import { apiClient } from "@/shared/api/client";
import {
    GetRiderPreSettlementListResponseDto,
    GetLatestSettlementDateResponseDto
} from "../types/riderPreSettlement.types";
import { getLatestSettlementDate, buildExcelDownloadUrl, downloadExcelFile } from "@/shared/utils/settlementApiHelpers";
import { formatDateToISO } from "@/shared/utils/dateUtils";

const BASE_PATH = '/api/v1/rider-pre-settlement';

/**
 * Rider Pre-Settlement API 서비스
 */
export const riderPreSettlementApi = {
    /**
     * 라이더 선정산내역 목록 조회
     * GET /api/v1/rider-pre-settlement?acctStDate={startDate}&acctEdDate={endDate}&riderName={name}&supplierId={id}
     */
    getRiderPreSettlementList: async (
        acctStDate: string,
        acctEdDate: string,
        riderName?: string,
        supplierId?: string
    ): Promise<GetRiderPreSettlementListResponseDto> => {
        // 날짜를 ISO 형식으로 변환
        const formattedStartDate = formatDateToISO(acctStDate);
        const formattedEndDate = formatDateToISO(acctEdDate);

        // URL을 직접 구성하여 배열 직렬화 문제 방지
        let url = `${BASE_PATH}?acctStDate=${formattedStartDate}&acctEdDate=${formattedEndDate}`;
        if (riderName && riderName.trim() !== '') {
            url += `&riderName=${encodeURIComponent(riderName)}`;
        }
        if (supplierId) {
            url += `&supplierId=${supplierId}`;
        }

        const response = await apiClient.get<GetRiderPreSettlementListResponseDto>(url);
        return response.data;
    },

    /**
     * 최근 선정산종료일자 조회
     * GET /api/v1/rider-pre-settlement/latest-date?supplierId={id}
     */
    getLatestSettlementDate: async (supplierId?: string): Promise<GetLatestSettlementDateResponseDto> => {
        let url = `${BASE_PATH}/latest-date`;
        if (supplierId) {
            url += `?supplierId=${supplierId}`;
        }
        const response = await apiClient.get<GetLatestSettlementDateResponseDto>(url);
        return response.data;
    },

    /**
     * 엑셀 다운로드
     * GET /api/v1/rider-pre-settlement/excel?acctStDate={startDate}&acctEdDate={endDate}&riderName={name}&supplierId={id}
     */
    downloadExcel: async (
        acctStDate: string,
        acctEdDate: string,
        riderName?: string,
        supplierId?: string
    ): Promise<Blob> => {
        const url = buildExcelDownloadUrl(BASE_PATH, {
            acctStDate,
            acctEdDate,
            riderName: riderName && riderName.trim() !== '' ? riderName : undefined,
            supplierId
        });
        return downloadExcelFile(url);
    }
};
